// src/modules/restaurant/pages/orders/components/order-details/OrderDetails.tsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { usePaymentTheme } from "../../../home/respayment/hooks/usePaymentTheme";
import { useOrderStatus } from "../../hooks/useOrderStatus";

import OrderHeader from "./OrderHeader";
import CustomerInfoCard from "./CustomerInfoCard";
import ProductList from "./ProductList";
import OrderSummary from "./OrderSummary";
import OrderActions from "./OrderActions";
// import { OrderList } from "../../types/orderTypes";
import { Order } from "src/shared/services/interfacev2";

interface OrderDetailsProps {
  selectedOrder: Order | null;
  onPrint: (order: Order) => void;
}

const OrderDetails: React.FC<OrderDetailsProps> = ({ selectedOrder, onPrint }) => {
  const { fontClass, themeTextColor, getBgClass, getLightBgClass, sidebarThemeClass } = usePaymentTheme();
  const navigate = useNavigate();
  const [showProducts, setShowProducts] = useState(true);
  const { isCancelled, isCompleted } = useOrderStatus(selectedOrder);

  const handlePayment = () => {
    if (!selectedOrder) return;
    navigate(`/v1/Respayment/${selectedOrder.orders[0].orderId}`);
  };

  if (!selectedOrder) {
    return (
      <div className={`flex flex-col items-center justify-center h-[91vh] w-[30vw] rounded-2xl text-center p-8 ${fontClass}`}>
        <div className="text-6xl text-gray-400 mb-4">
          <i className="fas fa-search"></i>
        </div>
        <h3 className={`text-xl font-semibold ${themeTextColor} mb-2`}>No Order Selected</h3>
        <p className="text-gray-500">Select an order from the list to view details</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl h-full flex flex-col">
      <OrderHeader selectedOrder={selectedOrder} getBgClass={getBgClass} isCancelled={isCancelled} isCompleted={isCompleted} />

      <div className={`thin-scrollbar flex-1 overflow-auto p-2 ${sidebarThemeClass}`}>
        <CustomerInfoCard selectedOrder={selectedOrder} themeTextColor={themeTextColor} getLightBgClass={getLightBgClass} isCancelled={isCancelled} isCompleted={isCompleted} />

        <ProductList selectedOrder={selectedOrder} getBgClass={getBgClass} getLightBgClass={getLightBgClass} showProducts={showProducts} setShowProducts={setShowProducts} />

        <OrderSummary selectedOrder={selectedOrder} themeTextColor={themeTextColor} getLightBgClass={getLightBgClass} />
      </div>

      {!isCancelled && (
        <OrderActions 
          onPrint={onPrint} 
          onPay={handlePayment} 
          getBgClass={getBgClass} 
          isCompleted={isCompleted} 
          total={selectedOrder.orders[0].finalAmount.toFixed(2) || 0} 
          selectedOrder={selectedOrder}
        />
      )}
    </div>
  );
};

export default OrderDetails;